import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { BaseComponent } from "../../base-module/base-component/base.component";
import { TipoBasketService } from "../services/tipo-basket.service";


export interface DialogData {
    id: number;
}

interface ITipo {
    id: number;
    nome: string;
}

@Component({
    selector: "app-filtra-basket",
    templateUrl: "./filtra-basket.component.html",
    styleUrls: ["./filtra-basket.component.scss"]
})

export class FiltraBasketComponent extends BaseComponent {

    primeiroDia = this._utilitesService.primeiroDiaMes();
    ultimoDia = this._utilitesService.ultimoDiaMes();

    rotulo = new FormControl("");
    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl(this.ultimoDia);
    tipo_id = new FormControl("");

    paramsStatus: any = {
        finalizada: ""
    };

    loadingSpinner!: boolean;
    listTipos: ITipo[] = [];


    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltraBasketComponent, { static: false }) table!: FiltraBasketComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltraBasketComponent>,
        private _utilitesService: UtilitesService,
        private _tipoBasketService: TipoBasketService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        super(dialog, snackBar);


        this.getAllTipos();
    }


    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar(): void {


        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(this.data_operacao_inicio.value ?? new Date());
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(this.data_operacao_fim.value ?? new Date());
        }

        this.dialogRef.close({
            "tipo_basket_id": this.tipo_id.value,
            "data_operacao_inicio": inic,
            "data_operacao_fim": fim,
            "nome_arquivo": this.rotulo.value,
        });
    }


    getAllTipos(): void {
        this.loadingSpinner = true;
        this._tipoBasketService.getAll({ no_paginate: true })
            .subscribe(
                resquest => {
                    this.listTipos = resquest.data;
                },
                error => {
                    this.loadingSpinner = false;
                },
                () => {
                    this.loadingSpinner = false;
                }
            );
    }


}